/**
 * SALE PRICES ON THE WEBSITE (Nordic Store, added 1 Oct 2026)
 *
 * While a sale in DEALS is running, the website shows it on the products it covers:
 * the normal price crossed out, the sale price next to it, a "20% off" tag on product
 * pictures, and a red bar at the top of every page. It switches on and off by itself
 * at the start/end times (UTC = Iceland time).
 * The real discount is the Shopify automatic discount with the same dates and products.
 *
 * everyone: true  -> every visitor sees the sale.
 * everyone: false -> only people who arrive from a link ending in ?deal=CODE see it.
 *
 * New sale: add one entry to DEALS.
 * Preview before a sale starts: add ?deal=CODE&deal_preview=1 to any page URL
 * (the preview only lasts until that browser tab is closed).
 */
(function () {
  var DEALS = {
    COFFEE25: {
      everyone: true,
      percent: 25,
      starts: '2026-10-01T12:35:00Z',
      ends: '2026-10-04T23:59:59Z',
      bar: 'International Coffee Day: 25% off Icelandic mugs',
      barExtra: ' · Ends Sunday 4 October',
      barLink: '/collections/mugs',
      barCta: 'Shop mugs',
      label: '25% off',
      note: 'Coffee Day sale: 25% off, taken off automatically at checkout.',
      handles: ['mug-jazz-puffin-silhouette-blue','mug-jazz-puffin-silhouette-red','mug-jazz-puffin-family-blue','mug-jazz-puffin-family-red','mug-jazz-hallgrimskirkja-blue','mug-jazz-hallgrimskirkja-red','mug-jazz-viking-blue','mug-jazz-viking-red','mug-two-tone-iceland-puffin','mug-two-tone-iceland-horse','mugg-two-tone-iceland-puffin-horse-volcano','mugg-horn-vikings-flames-iceland']
    },
    LEIF20: {
      everyone: false,
      percent: 20,
      starts: '2026-10-06T00:00:00Z',
      ends: '2026-10-11T23:59:59Z',
      bar: 'Leif Erikson Day: 20% off all wool sweaters',
      barExtra: ' · Ends Sunday 11 October',
      barLink: '/collections/icelandic-wool-sweaters',
      barCta: 'Shop sweaters',
      label: '20% off',
      note: 'Leif Erikson Day sale: 20% off, taken off automatically at checkout.',
      handles: ['icelandic-sweater-traditional-blue-men','icelandic-sweater-skipper-pullover-grey-men','icelandic-sweater-traditional-grey-men','icelandic-sweater-skipper-pullover-woman-white','icelandic-sweater-skipper-hood-woman-grey','icelandic-sweater-traditional-black-men','icelandic-sweater-skipper-pullover-grey-woman','icelandic-sweater-traditional-blue-woman','icelandic-sweater-traditional-grey-woman','icelandic-sweater-skipper-hood-woman-white','icelandic-sweater-fonn-woman-blue','icelandic-sweater-skipper-pullover-men-black','icelandic-sweater-skipper-hood-woman-black-1','icelandic-sweater-fonn-woman-black','icelandic-sweater-traditional-black-woman','icelandic-sweater-skipper-hood-men-black','icelandic-sweater-skipper-hood-men-grey','icelandic-sweater-skipper-men-grey','icelandic-sweater-skipper-pullover-black-woman','icelandic-sweater-skipper-men-black','icelandic-sweater-skipper-cardigan-woman-white','icelandic-sweater-skipper-woman-grey','icelandic-sweater-skipper-hood-men-white','icelandic-sweater-fonn-men-black','icelandic-sweater-skipper-woman-black','icelandic-sweater-skipper-pullover-men-white','bjarni-wool-brown-icelandic-sweater','icelandic-sweater-eykt-blue','icelandic-sweater-eykt-grey','icelandic-sweater-hruni-blue','icelandic-sweater-tight-fit-black','icelandic-sweater-gudbjartur-black','icelandic-sweater-skipper-cardigan-men-white','icelandic-sweater-tight-fit-white','icelandic-sweater-hruni-black','icelandic-sweater-hruni-red','eykt-wool-pullover-yellowicelandicsweater','icelandic-sweater-hruni-green','icelandic-sweater-eykt-red','icelandic-sweater-hruni-grey','icelandic-sweater-eykt-brown','icelandic-sweater-gudbjartur-sheep','wool-vest-whiteicelandicsweater','woolvestgreyicelandicsweater','icelandic-sweater-eykt-green','woolvestblackicelandicsweater','fonn-wool-sweater-grey','bjarni-wool-cardigan-grey','tight-fit-wool-pullover-dark-grey','hruni-wool-cardigan-icelandic-sweater-hruni-brown','icelandic-sweater-goa-brown','eykt-wool-pullover-black','eykt-wool-pullover-rose-heather','hruni-wool-cardigan-light-green','hruni-wool-cardigan-dark-red','icelandic-sweater-goa-grey']
    }
  };

  var STORE_KEY = 'ns_email_deal';

  // A preview only lasts until the browser tab is closed; a real deal is remembered until it ends.
  function readStored() {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORE_KEY) || window.localStorage.getItem(STORE_KEY) || 'null');
    } catch (e) { return null; }
  }
  function store(code, preview) {
    try {
      var value = JSON.stringify({ code: code, preview: !!preview });
      if (preview) { window.sessionStorage.setItem(STORE_KEY, value); }
      else { window.localStorage.setItem(STORE_KEY, value); }
    } catch (e) {}
  }
  function isRunning(code, preview) {
    var deal = DEALS[code];
    if (!deal) return false;
    if (preview) return true;
    var now = Date.now();
    return now >= Date.parse(deal.starts) && now <= Date.parse(deal.ends);
  }
  function activeCode() {
    var s = readStored();
    if (s && isRunning(s.code, s.preview)) return s.code;
    for (var code in DEALS) {
      if (DEALS[code].everyone && isRunning(code, false)) return code;
    }
    return null;
  }

  // 1) Code from the email link (?deal=CODE)
  var params = new URLSearchParams(window.location.search);
  var urlCode = (params.get('deal') || '').toUpperCase();
  if (DEALS[urlCode]) store(urlCode, params.get('deal_preview') === '1');

  // 2) Older Shopify behaviour: discount_code cookie from a /discount/CODE link
  var cookieMatch = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
  if (cookieMatch && !activeCode()) {
    var cookieCode = decodeURIComponent(cookieMatch[1]).toUpperCase();
    if (DEALS[cookieCode]) store(cookieCode, false);
  }

  function formatMoney(cents) {
    var t = window.theme || {};
    var format = (t.currencyCodeEnabled ? t.moneyWithCurrencyFormat : t.moneyFormat) || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = match ? match[1] : 'amount';
    function group(value, decimals, thousands, decimal) {
      var parts = (value / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    var out;
    switch (kind) {
      case 'amount_no_decimals': out = group(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = group(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = group(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = group(cents, 2, "'", '.'); break;
      default: out = group(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  function dealCents(cents, percent) {
    return cents - Math.round(cents * percent / 100);
  }
  function handleFromUrl(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function priceFromText(text) {
    var m = (text || '').replace(/,/g, '').match(/(\d+(?:\.\d{1,2})?)/);
    return m ? Math.round(parseFloat(m[1]) * 100) : null;
  }

  // Product grids (collection pages, search, recommendations)
  function applyCards(code) {
    var deal = DEALS[code];
    var items = document.querySelectorAll('.ProductItem');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var list = item.querySelector('.ProductItem__PriceList');
      if (!list || list.querySelector('.ns-deal-price')) continue;
      var link = item.querySelector('a[href*="/products/"]');
      var handle = link && handleFromUrl(link.getAttribute('href'));
      if (!handle || deal.handles.indexOf(handle) === -1) continue;
      var first = list.querySelector('.ProductItem__Price');
      var cents = priceFromText(first ? first.textContent : list.textContent);
      if (!cents) continue;
      list.innerHTML =
        '<span class="ProductItem__Price Price Price--highlight Text--subdued ns-deal-price">' + formatMoney(dealCents(cents, deal.percent)) + '</span> ' +
        '<span class="ProductItem__Price Price Price--compareAt Text--subdued">' + formatMoney(cents) + '</span>';
      if (deal.label && !item.querySelector('.ns-deal-label')) {
        var labels = item.querySelector('.ProductItem__LabelList');
        if (!labels) {
          labels = document.createElement('div');
          labels.className = 'ProductItem__LabelList';
          var image = item.querySelector('.ProductItem__ImageWrapper');
          if (image && image.parentNode) image.parentNode.insertBefore(labels, image.nextSibling);
        }
        var tag = document.createElement('span');
        tag.className = 'ProductItem__Label ProductItem__Label--onSale Heading Text--subdued ns-deal-label';
        tag.textContent = deal.label;
        labels.insertBefore(tag, labels.firstChild);
      }
    }
  }

  // Red bar at the very top of every page
  function applyBar(code) {
    var deal = DEALS[code];
    if (!deal.bar || document.getElementById('ns-deal-bar')) return;
    var container = document.querySelector('.PageContainer');
    if (!container) return;
    if (!document.getElementById('ns-deal-bar-style')) {
      var style = document.createElement('style');
      style.id = 'ns-deal-bar-style';
      style.textContent =
        '#ns-deal-bar{background:#e32c2b;color:#fff;text-align:center;padding:10px 16px;}' +
        '#ns-deal-bar a{color:#fff;text-decoration:none;}' +
        '#ns-deal-bar .ns-deal-bar__text{margin:0;font-size:12px;line-height:1.5;letter-spacing:.15em;text-transform:uppercase;}' +
        '#ns-deal-bar .ns-deal-bar__cta{margin-left:12px;text-decoration:underline;font-weight:bold;white-space:nowrap;}' +
        '@media (max-width:640px){#ns-deal-bar .ns-deal-bar__extra{display:none;}}';
      document.head.appendChild(style);
    }
    var bar = document.createElement('div');
    bar.id = 'ns-deal-bar';
    var text = document.createElement('p');
    text.className = 'ns-deal-bar__text Heading';
    var link = document.createElement('a');
    link.href = deal.barLink || '#';
    link.appendChild(document.createTextNode(deal.bar));
    if (deal.barExtra) {
      var extra = document.createElement('span');
      extra.className = 'ns-deal-bar__extra';
      extra.textContent = deal.barExtra;
      link.appendChild(extra);
    }
    if (deal.barCta) {
      var cta = document.createElement('span');
      cta.className = 'ns-deal-bar__cta';
      cta.textContent = deal.barCta + ' →';
      link.appendChild(cta);
    }
    text.appendChild(link);
    bar.appendChild(text);
    container.insertBefore(bar, container.firstChild);
    var announcement = document.getElementById('shopify-section-announcement');
    var height = bar.offsetHeight + (announcement ? announcement.offsetHeight : 0);
    document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
  }

  // Product pages and featured-product sections
  function productData(section) {
    if (section.__nsProduct !== undefined) return section.__nsProduct;
    var script = section.querySelector('script[data-product-json]');
    var data = null;
    try { data = script ? JSON.parse(script.textContent) : null; } catch (e) { data = null; }
    section.__nsProduct = data;
    return data;
  }
  function applyProducts(code) {
    var deal = DEALS[code];
    var lists = document.querySelectorAll('.ProductMeta__PriceList');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      var section = list.closest('[data-section-type]') || document;
      var data = productData(section);
      if (!data || !data.product || deal.handles.indexOf(data.product.handle) === -1) continue;
      var variantId = section.__nsVariantId || data.selected_variant_id;
      var variant = null;
      for (var v = 0; v < data.product.variants.length; v++) {
        if (data.product.variants[v].id === variantId) variant = data.product.variants[v];
      }
      var cents = variant ? variant.price : data.product.price;
      var existing = list.querySelector('.ns-deal-price');
      if (existing && existing.getAttribute('data-ns-cents') === String(cents)) continue;
      list.innerHTML =
        '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4 ns-deal-price" data-ns-cents="' + cents + '">' + formatMoney(dealCents(cents, deal.percent)) + '</span> ' +
        '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4">' + formatMoney(cents) + '</span>';
      var next = list.nextElementSibling;
      if (deal.note && !(next && next.classList.contains('ns-deal-note'))) {
        var note = document.createElement('p');
        note.className = 'ns-deal-note Text--subdued';
        note.style.cssText = 'margin:6px 0 0;font-size:13px;line-height:1.5;';
        note.textContent = deal.note;
        list.parentNode.insertBefore(note, list.nextSibling);
      }
    }
  }

  function apply() {
    var code = activeCode();
    if (!code) return;
    applyBar(code);
    applyCards(code);
    applyProducts(code);
  }

  document.addEventListener('variant:changed', function (event) {
    var section = event.target.closest ? event.target.closest('[data-section-type]') : null;
    if (section && event.detail && event.detail.variant) section.__nsVariantId = event.detail.variant.id;
    setTimeout(apply, 0);
  });

  function start() {
    apply();
    if (!activeCode()) return;
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
